import styled from "@emotion/styled";
import {colors, fontSize, sizes} from "patient-ping-remedy/packages/theme";
import {HintTypography, LabelTypography, SmallTypography, StandardTypography} from "patient-ping-remedy/packages/typography";

export const ModalContent = styled.div`
    display: flex; 
    flex-direction: column;
`;

export const ModalRow = styled.div`
  display: flex;
    flex-direction: row;
    gap: 1.5rem;

    > * {
      flex: 1;
      min-width: 0;
    }
`;

export const TemplateContent = styled.div`
    margin-top: 1rem;
    display: flex;
    flex-direction: column;
`;

export const TemplateField = styled.div`
  margin-top: ${sizes.small};
  display: flex;
  flex-direction: column;
`;

export const TemplateLabel = styled(LabelTypography)``;

export const RequiredMarker = styled.span`
  color: ${colors.red5};
  font-weight: 600;
`;

export const OptionalMarker = styled(SmallTypography)`
  color: ${colors.gray4};
`;

export const StyledTextarea = styled.textarea`
  width: 100%;
  min-height: 8rem;
  resize: vertical;
  font-family: inherit;
  font-size: ${fontSize.standard};
  padding: ${sizes.xSmall};
  margin-top: ${sizes.xxSmall};
  border-radius: 0;
  border: 0.1rem solid ${colors.gray2};

  &:focus {
    border: 0.1rem solid ${colors.purple3};
    outline: none;
  }

  &::placeholder {
    color: ${colors.gray4};
  }
`;

export const VariableHint = styled(HintTypography)`
  margin-top: ${sizes.xxSmall};
  color: ${colors.gray4};
`;

export const PreviewBlock = styled.div`
  margin-top: ${sizes.small};
  padding: ${sizes.xSmall};
  background-color: ${colors.gray1};
  border-left: 0.3rem solid ${colors.purple3};
`;

export const PreviewText = styled(StandardTypography)`
  display: block;
  margin-top: ${sizes.xxSmall};
  white-space: pre-wrap;
`;
